export const routes = {
  // admin: "/account/admin",
  adminPanel: {
    acceptances: "/account/admin-panel/acceptances",
    awaitingLive: "/account/admin-panel/awaiting-live",
    base: "/account/admin-panel",
    dead: "/account/admin-panel/dead",
    failedCredit: "/account/admin-panel/failed-credit",
    live: "/account/admin-panel/live",
    objections: "/account/admin-panel/objections",
    paSettled: "/account/admin-panel/pa-settled",
    preaction: "/account/admin-panel/preaction",
    rejections: "/account/admin-panel/rejections",
    submissions: "/account/admin-panel/submissions"
  },
  callbacks: "/account/callbacks",
  calls: "/account/calls",
  campaign: "/account/campaign",
  campaignReport: "/account/campaign/[campaignId]",
  companies: "/account/companies",
  company: "/account/companies/[id]",
  companyActivity: "/account/companies/[id]/activity",
  companyContacts: "/account/companies/[id]/contacts",
  companyFiles: "/account/companies/[id]/files",
  companyNotes: "/account/companies/[id]/notes",
  companyPool: "/account/companies/[id]/pool",
  companySite: "/account/companies/[id]/sites/[siteRefId]",
  companySites: "/account/companies/[id]/sites",
  compliance: {
    base: "/account/compliance",
    inProgress: "/account/compliance/in-progress",
    new: "/account/compliance/new"
  },
  contacts: "/account/contacts",
  contracts: "/account/contracts",
  creditCheck: "/account/credit-check",
  // All other routes.
  dashboard: "/account/dashboard",
  dealOverview: "/account/deals/[dealId]/overview",
  deals: "/account/deals",
  dealTranscription: "/account/deals/[dealId]/transcription",
  forgotPassword: "/authentication/forgot-password",
  getQuotes: "/account/get-quotes",
  // The default route to redirect to when the user is logged in.
  HOME: "/account/quotes",
  interactions: "/account/interactions",
  leadGen: {
    base: "/account/lead-gen",
    conversions: "/account/lead-gen/conversions",
    passedOver: "/account/lead-gen/passed-over",
    passovers: "/account/lead-gen/passovers"
  },
  loa: "/account/loa",
  login: "/authentication/login",
  magicLink: "/authentication/magic-link",
  notes: "/account/notes",
  notifications: "/account/notifications",
  people: "/account/people",
  pools: "/account/pools",
  priceLists: "/account/price-lists",
  quotes: "/account/quotes",
  recordings: "/account/recordings",
  roles: "/account/roles",
  settings: "/settings",
  signableContractTemplates: "/account/signable-contract-templates",
  sites: "/account/sites",
  statistics: "/statistics",
  updatePassword: "/authentication/update-password",
  users: "/account/users",
  verbalTemplates: "/account/verbal-templates",
  viewQuotes: "/account/view-quotes/[quoteListId]",
  workbook: "/account/workbook"
} as const;

/** Deals list with submit-to-compliance modal open for the given deal. */
export function dealSubmitToComplianceHref(dealId: string): string {
  const params = new URLSearchParams({
    dealId,
    modal: "submit-deal"
  });
  return `${routes.deals}?${params.toString()}`;
}

/** Path for admin pipeline category tabs (matches `COMPLIANCE_NAV_CATEGORY_IDS`). */
export function adminPanelCategoryHref(categoryId: string): string {
  return `/account/admin-panel/${categoryId}`;
}

/** Path for lead gen category tabs. */
export function leadGenCategoryHref(categoryId: string): string {
  return `/account/lead-gen/${categoryId}`;
}
